import React from "react";
import Navigation from "./navigation/Navigation";
import Step1 from "./steps/Step1";
import SubscriptionFooter from "./SubscriptionFooter";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";
import Step5 from "./steps/Step5";

export default function FormContainer() {
	return (
		<section className="container">
			<Navigation navLength={5} />
			<Step1 formStep={0} title="What are you looking for?" />
			<Step2 formStep={1} title="What is your E-Mail Address?" />
			<Step3 formStep={2} title="What Industry are you interested in?" />
			<Step4 formStep={3} title="In what Industry do you work?" />
			<Step5
				formStep={4}
				title="Thanks, we received your information. We will get back to you shortly."
				subtitle="If you want to get the free newsletter, please give us more information about you."
			/>
			<SubscriptionFooter />
		</section>
	);
}
